module.exports = __webpack_public_path__ + "img/route.e2ac1aba.svg";